import "./TableCategorie.css";
import React from "react";
import { GoPrimitiveDot } from 'react-icons/go'
import programmation from '../../Assets/programmation.jpg'
import design from '../../Assets/design.png'
import gestionProjet from '../../Assets/gestionProjet.jpg'
import digital from '../../Assets/digital.png'
import { SamaDate } from "../../Services";

function TableCategorie({ item }) {
  let couleur = '';
  let contenu = '';
  item?.isApproved === true ? couleur = 'green' : couleur = 'red';
  item?.isApproved === true ? contenu = 'Live' : contenu = 'Pending';
  const Affiche = (domaine) => {
    if (domaine?.toLowerCase() === 'programmation') {
      return (<img src={programmation} alt="images" className="mab p-2" />)
    } else if (domaine?.toLowerCase() === 'design') { 
      return (<img src={design} alt="images" className="mab p-2" />)
    } else if (domaine?.toLowerCase() === 'gestion de projet') {
      return (<img src={gestionProjet} alt="images" className="mab p-2" />)
    } else if (domaine?.toLowerCase() === 'marketing digital') {
      return (<img src={digital} alt="images" className="mab p-2" />)
    }

  }

  return (
    <tr>
      <td className="d-flex justify-center align-items-center listCours p-2 ">
        <div className="container-im">
          {Affiche(item?.domaine)}
        </div>
        <div>
          <span className="fw-bold text-uppercase" >{item?.titre_cours}</span><br />
          <span> {item?.description}</span><br />
          <span className="text-muted" >Ajouté par {item?.infoUser}</span>
        </div>
      </td>
      <td>{<SamaDate mydate={item?.created_on} />}</td>
      <td className=" p-3 "><GoPrimitiveDot style={{ color: `${couleur}` }} />{contenu}</td>
    </tr>

  );
};

export default TableCategorie;
